import React, { useEffect, useState } from "react";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Pagination from "@mui/material/Pagination";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";
import MDTypography from "components/MDTypography";

import Swal from "sweetalert2";

import Loader from "Loader";
import SearchAccSessionReq from "../../../Classes/Models/Requests/AccountingSessions/CreateAccountingSessionReq";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "App";
import SessionsApi from "../../../Classes/API/Administration/SessionsApi";
import SearchStringOrIntReq3 from "../../../Classes/Models/Requests/SearchStringOrIntReq";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import SearchSingleSessions from "./SearchSingleSessions";
import AddmissionButton from "../AddmissionButton";
import AccountingApi from "Classes/API/AccountingApi";
import { useContext } from "react";
import * as XLSX from "xlsx";

const SingleSessionsTable = ({ CurrentUser, setCreatedNewSession, CreatedNewSession }) => {
  let navigate = useNavigate();

  const [SearchReq, setSearchReq] = useState(new SearchAccSessionReq());
  const [TotalAccountingItems, setTotalAccountingItems] = useState(0);
  const { translations } = useContext(LanguageContext);
  const TableColumns = [
    {
      Header: translations.createAccountsessionSingleSessionSearchTableAccSessionID,
      accessor: "Id",
      align: "left",
    },

    {
      Header: translations.createAccountsessionSingleSessionSearchTableSession,
      accessor: "Session",
      align: "left",
    },
    {
      Header: translations.createAccountsessionSingleSessionSearchTablePatient,
      accessor: "Patient",
      align: "left",
    },

    {
      Header: translations.createAccountsessionSingleSessionSearchTableTherapist,
      accessor: "Therapist",
      align: "left",
    },
    {
      Header: translations.createAccountsessionSingleSessionSearchTablePaidFor,
      accessor: "PaidFor",
      align: "left",
    },
    {
      Header: translations.createAccountsessionSingleSessionSearchTableAddmission,
      accessor: "Addmission",
      align: "left",
    },
    {
      Header: translations.createAccountsessionSingleSessionSearchTableAppointmentTime,
      accessor: "AppointmentTime",
      align: "left",
    },
    {
      Header: translations.createAccountsessionSingleSessionSearchTableOriginalPrice,
      accessor: "OriginalPrice",
      align: "left",
    },
    {
      Header: translations.createAccountsessionSingleSessionSearchTableDiscount,
      accessor: "Discount",
      align: "left",
    },
    {
      Header: translations.createAccountsessionSingleSessionSearchTableFinalPrice,
      accessor: "FinalPrice",
      align: "left",
    },

    {
      Header: translations.createAccountsessionSingleSessionSearchTableDetails,
      accessor: "Edit",
      align: "center",
    },
    {
      Header: translations.createAccountsessionSingleSessionSearchTableDelete,
      accessor: "Delete",
      align: "center",
    },
  ];

  const [TableDataRows, setTableDataRows] = useState([]);

  const [ResponseData, setResponseData] = useState({});
  const [PaginationPages, setPaginationPages] = useState(0);
  const [Page, setPage] = useState(1);

  const [IsLoaded, setIsLoaded] = useState(false);
  const [IsSearching, setIsSearching] = useState(false);

  const GetTherapistSessions = async () => {
    let req = new SearchStringOrIntReq3();

    req.SearchInt = CurrentUser.getTherapist.id;

    console.log(req);

    var res = await SessionsApi.GetTherapistAccountingSessions(req);

    console.log(res);
    if (res.status == "Success") {
      let tempResponseData = [...res.data.list];
      setResponseData(tempResponseData);
      setIsLoaded(true);
    }
  };

  const DeleteSession = async (id) => {
    if (CurrentUser.userType != "Admin") {
      Swal.fire({
        title: "Sorry, you do not have this permission.",
        text: "Visit your admin to request this permission.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.value) {
        let delReq = new SearchStringOrIntReq3();
        delReq.SearchInt = id;
        var res = await SessionsApi.DeleteAccountingSession(delReq);

        if (res.status == "Success") {
          Swal.fire("Deleted!", "Session has been deleted.", "success");
          setIsLoaded(false);
        } else {
          Swal.fire("Failed!", res.message, "error");
        }
      }
    });
  };

  const GetOptions = (session) => {
    if (
      CurrentUser.userType != "Admin" &&
      CurrentUser.userType != "Therapist" &&
      CurrentUser.userType != "AccountingEmployee" &&
      CurrentUser.userType != "AppointmentEmployee"
    ) {
      Swal.fire({
        title: "Access Denied",
        text: "Visit your admin to request this permission.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    if (CurrentUser.userType === "Therapist") {
      navigate("/AccountingSessions/Details", {
        state: {
          SearchSession: session,
        },
      });
    } else {
      navigate("/AccountingSessions/Details", {
        state: {
          SearchSession: session,
        },
      });
    }
  };

  const MakeTableRow = (session, index) => {
    console.log("MakeTableRow", session);

    return {
      Id: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.id}
        </MDTypography>
      ),

      Session: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.sessionName}
        </MDTypography>
      ),

      Patient: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.patientName}
        </MDTypography>
      ),
      Therapist: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.therapistName}
        </MDTypography>
      ),
      PaidFor: (
        <input
          id={"S.isPaidFor" + session.id}
          type="checkbox"
          disabled
          checked={session.isPaidFor ? "on" : ""}
        />
      ),
      Addmission: <AddmissionButton AccSession={session} />,
      AppointmentTime: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.appointmentTime === null
            ? "No Appointment Time"
            : new Date(session.appointmentTime).toLocaleString()}
        </MDTypography>
      ),
      OriginalPrice: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.originalPrice}
        </MDTypography>
      ),

      Discount: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Number(session.discount).toFixed(1)}%
        </MDTypography>
      ),

      FinalPrice: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.finalPrice}
        </MDTypography>
      ),

      Edit: (
        <MDTypography
          onClick={() => {
            GetOptions(session);
          }}
          component="a"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          <Icon>more_vert</Icon>
        </MDTypography>
      ),
      Delete: (
        <MDButton onClick={() => DeleteSession(session.id)} variant="gradient" color="dark">
          <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
        </MDButton>
      ),
    };
  };

  useEffect(() => {
    console.log("SearchReq", SearchReq);
  }, [SearchReq]);
  const GetTableData = async () => {
    SearchReq.pagingParams.pageSize = 5;
    SearchReq.pagingParams.pageNumber = Page;
    // SearchReq.patientId = CurrentUser.getPatient?.id
    console.log({ SearchReq });
    var res = await SessionsApi.SearchAccountingSessions(SearchReq);
    if (res.status == "Success") {
      let tempResponseData = [...res.data.list];
      setResponseData(tempResponseData);
      setTotalAccountingItems(res.data.totalItems);
      setPaginationPages(res.data.totalPages);
      setIsLoaded(true);
    }
  };

  useEffect(() => {
    GetTableData();
  }, [Page]);

  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((session, index) => {
      rows.push(MakeTableRow(session, index));
    });
    setTableDataRows(rows);
  };

  useEffect(async () => {
    //Get data

    if (!IsLoaded || CreatedNewSession) {
      await GetTableData();
      setCreatedNewSession(false);
    }
  }, [IsLoaded, CreatedNewSession, TotalAccountingItems]);

  useEffect(() => {
    //Get data

    if (ResponseData.length > 0) {
      RefreshTable(ResponseData);
    } else {
      setTableDataRows([]);
    }
  }, [ResponseData]);

  const ExportExcelList = async () => {
    Swal.fire({
      title: "Preparing Export",
      html: `
        <div>
          <p>Fetching data...</p>
        </div>
      `,
      icon: "info",
      didOpen: () => {
        Swal.showLoading();
        Swal.getHtmlContainer().querySelector(".progress-text");
      },
    });

    try {
      console.log("SearchReq before API call:", SearchReq);
      // Create export request with server-side limit
      const exportReq = {
        ...SearchReq,
      };

      // Get data from backend
      const response = await AccountingApi.GetAccountingSessionsForExport(exportReq);

      if (response.status === "Success" && response.data?.length > 0) {
        // Transform data
        const excelData = response.data.map((session) => ({
          "Session ID": session.id || "N/A",
          "Session Name": session.sessionName || "N/A",
          "Patient Name": session.patientName || "N/A",
          "Therapist Name": session.therapistName || "N/A",
          "Original Price": session.originalPrice || 0,
          Discount: session.discount ? `${session.discount.toFixed(2)}%` : "0%",
          "Final Price": session.finalPrice || 0,
          "Appointment Time": session.appointmentTime
            ? new Date(session.appointmentTime).toLocaleString()
            : "No Appointment",
          "Created At": new Date(session.timeStamp).toLocaleString(),
          "Is Paid": session.isPaidFor ? "Yes" : "No",
          "Is Exception": session.isException ? "Yes" : "No",
          "Is Absent": session.isAbsent ? "Yes" : "No",
        }));

        // Calculate statistics
        const stats = {
          totalSessions: excelData.length,
          totalAbsent: excelData.filter((x) => x["Is Absent"] === "Yes").length,
          totalFinalPrice: excelData.reduce((sum, x) => sum + x["Final Price"], 0),
          totalNotPaid: excelData.filter((x) => x["Is Paid"] === "No").length,
          totalPaid: excelData.filter((x) => x["Is Paid"] === "Yes").length,
          totalDiscount: excelData.reduce((sum, x) => {
            const discount = parseFloat(x["Discount"]) || 0;
            return sum + (x["Original Price"] * discount) / 100;
          }, 0),
          totalException: excelData.filter((x) => x["Is Exception"] === "Yes").length,
        };
        stats.averageFinalPrice = stats.totalFinalPrice / stats.totalSessions;

        // Convert data to worksheet
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Accounting Sessions");

        // Set column widths
        const colWidths = [
          { wch: 15 }, // Session ID
          { wch: 30 }, // Session Name
          { wch: 25 }, // Patient Name
          { wch: 25 }, // Therapist Name
          { wch: 15 }, // Original Price
          { wch: 15 }, // Discount
          { wch: 15 }, // Final Price
          { wch: 25 }, // Appointment Time
          { wch: 25 }, // Created At
          { wch: 10 }, // Is Paid
          { wch: 15 }, // Is Exception
          { wch: 15 }, // Is Absent
        ];
        ws["!cols"] = colWidths;

        // Add statistics as a new worksheet
        const statsData = [
          ["STATISTICS", ""],
          ["Total Accounting Sessions", stats.totalSessions],
          ["Total Absent Accounting Sessions", stats.totalAbsent],
          ["Total Final Price", stats.totalFinalPrice.toFixed(2)],
          ["Total Not Paid Sessions", stats.totalNotPaid],
          ["Total Paid Sessions", stats.totalPaid],
          ["Total Discount Amount", stats.totalDiscount.toFixed(2)],
          ["Average Final Price", stats.averageFinalPrice.toFixed(2)],
          ["Total Exception Sessions", stats.totalException],
        ];

        const statsWs = XLSX.utils.aoa_to_sheet(statsData);
        XLSX.utils.book_append_sheet(wb, statsWs, "Statistics");
        statsWs["!cols"] = [
          { wch: 30 }, // First column (statistic names)
          { wch: 10 }, // Second column (values)
        ];

        // Generate file
        const fileName = `Accounting_Sessions_${new Date().toISOString().split("T")[0]}.xlsx`;
        XLSX.writeFile(wb, fileName);

        Swal.fire({
          title: "Export Complete",
          icon: "success",
        });
      } else {
        Swal.fire("No Data", "No sessions found matching your criteria", "info");
      }
    } catch (error) {
      console.error("Export failed:", error);
      Swal.fire("Export Failed", error.message || "An error occurred during export", "error");
    }
  };

  return (
    <>
      {(CurrentUser.userType == "Admin" ||
        CurrentUser.userType == "AccountingEmployee" ||
        CurrentUser.userType == "AppointmentEmployee" ||
        CurrentUser.userType == "Therapist" ||
        CurrentUser.userType == "FloorManager") && (
        <SearchSingleSessions setSearchReq={setSearchReq} GetTableData={GetTableData} />
      )}
      {IsSearching ? (
        <Loader type="balls" color="black" />
      ) : (
        <Card style={{ marginTop: "70px" }}>
          <MDBox
            mx={2}
            mt={-5}
            py={3}
            px={2}
            sx={{ backgroundColor: "#3560AD" }}
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <div class="text-center">
              <MDTypography variant="h4" color="white">
                {translations.createAccountsessionSingleSessionSearchTableAccountingSessionstable}
              </MDTypography>
              <MDTypography className="h6" color="white">
                <strong>
                  {translations.createAccountsessionSingleSessionSearchTableTotalItems}:{" "}
                  {TotalAccountingItems}
                </strong>
              </MDTypography>
            </div>
            <div class="text-right">
              <MDBox className="search-button-container">
                <MDButton
                  onClick={() => {
                    ExportExcelList();
                  }}
                  sx={{
                    backgroundColor: "#333333",
                    "&:hover": { backgroundColor: "#3560AD", border: "1px solid white" },
                  }}
                  color="dark"
                >
                  &nbsp;{translations.createAccountsessionSingleSessionSearchTableGenerateReport}
                </MDButton>
              </MDBox>
            </div>
            {CurrentUser && CurrentUser.userType == "Therapist" && (
              <MDButton
                onClick={() => {
                  GetTherapistSessions();
                }}
                variant="gradient"
                color="light"
              >
                <Icon sx={{ fontWeight: "bold" }}>search</Icon>
                <MDTypography
                  component="span"
                  sx={{ backgroundColor: "#4682B4", "&:hover": { backgroundColor: "#B0DFE5" } }}
                  color="text"
                  fontWeight="medium"
                >
                  {translations.createAccountsessionSingleSessionSearchTableFindMySessions}
                </MDTypography>
              </MDButton>
            )}
          </MDBox>
          <MDBox p={3}>
            <DataTable
              table={{ columns: TableColumns, rows: TableDataRows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
            />
            <div className="text-right mx-3 my-4">
              <Pagination
                count={PaginationPages}
                color="primary"
                onChange={(e, num) => setPage(num)}
                className="float-right"
              />
            </div>
          </MDBox>
        </Card>
      )}
    </>
  );
};

export default SingleSessionsTable;
